var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP2TipBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 75,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 6.56964,
    height: 0.664263,
    transform: "matrix(1 6.09627e-05 6.02928e-05 1 16.2747 20.502)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 20,
    width: 7,
    height: 28
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6031 20.502L22.5158 20.5023L22.1878 27.8092L21.9688 27.8092L21.8595 31.1305L21.4785 31.1305L20.2181 47.0727L18.9041 47.0726L17.6418 31.1302L17.2608 31.1302L17.1511 27.8089L16.9321 27.8089L16.6031 20.502Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.6031 20.502L22.5158 20.5023L22.1878 27.8092L16.9321 27.8089L16.6031 20.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.1292 27.1445L21.9907 27.1448L21.8595 31.1304L17.2608 31.1301L17.1292 27.1445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.5892 30.4658L21.531 30.4661L20.218 47.0726L18.9041 47.0725L17.5892 30.4658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 1.31393,
    height: 0.664263,
    transform: "matrix(1 6.09627e-05 6.02928e-05 1 18.9041 47.0723)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M18.2461 30.4659L19.1012 47.0725L18.9041 47.0725L17.6549 31.1301L17.2607 31.1301L17.1291 27.8088L16.9321 27.8088L16.6032 21.1661L17.5886 20.834L18.2461 30.4659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M20.874 30.4657L20.0209 47.0722L20.218 47.0722L21.4653 31.13L21.8595 31.13L21.9907 27.8087L22.1877 27.8087L22.5158 21.1661L21.5304 20.8339L20.874 30.4657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8444 21.1664L16.3861 21.166L16.2748 21.8303L22.8221 21.8307L22.8444 21.1664ZM17.0323 27.8087L22.8448 27.809L22.8248 28.4733L16.9321 28.4729L17.0323 27.8087ZM17.6549 31.13L21.4653 31.1303L21.4522 31.7945L17.5893 31.7943L17.6549 31.13Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 6.56964,
    height: 0.664263,
    transform: "matrix(1 6.09612e-05 6.02914e-05 1 43.5914 20.3525)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 20,
    width: 7,
    height: 27
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9199 20.3525L49.8326 20.3529L49.5046 27.6598L49.2856 27.6598L49.1763 30.9811L48.7952 30.981L47.5348 46.9233L46.2209 46.9232L44.9586 30.9808L44.5776 30.9808L44.4679 27.6595L44.2488 27.6595L43.9199 20.3525Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.9199 20.3525L49.8326 20.3529L49.5046 27.6598L44.2488 27.6595L43.9199 20.3525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M44.4459 26.9951L49.3074 26.9954L49.1763 30.981L44.5776 30.9807L44.4459 26.9951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M44.9059 30.3164L48.8477 30.3166L47.5348 46.9231L46.2209 46.9231L44.9059 30.3164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 1.31393,
    height: 0.664263,
    transform: "matrix(1 6.09612e-05 6.02914e-05 1 46.2209 46.9229)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M45.5629 30.3165L46.418 46.9231L46.2209 46.9231L44.9717 30.9807L44.5775 30.9807L44.4459 27.6594L44.2488 27.6594L43.9199 21.0167L44.9054 20.6846L45.5629 30.3165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M48.1908 30.3163L47.3377 46.9228L47.5348 46.9228L48.7821 30.9806L49.1762 30.9806L49.3074 27.6593L49.5045 27.6593L49.8326 21.0167L48.8471 20.6845L48.1908 30.3163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1611 21.017L43.7028 21.0166L43.5915 21.6809L50.1389 21.6813L50.1611 21.017ZM44.3491 27.6593L50.1615 27.6596L50.1415 28.3239L44.2489 28.3235L44.3491 27.6593ZM44.9717 30.9806L48.7821 30.9809L48.769 31.6451L44.9061 31.6449L44.9717 30.9806Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 6.56964,
    height: 0.664263,
    transform: "matrix(1 6.09612e-05 6.02914e-05 1 30.5957 20.4238)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 20,
    width: 7,
    height: 27
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9242 20.4238L36.8369 20.4242L36.5088 27.7311L36.2898 27.731L36.1806 31.0524L35.7995 31.0523L34.5391 46.9946L33.2252 46.9945L31.9628 31.0521L31.5818 31.0521L31.4721 27.7308L31.2531 27.7307L30.9242 20.4238Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M30.9242 20.4238L36.8369 20.4242L36.5088 27.7311L31.2531 27.7307L30.9242 20.4238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M31.4502 27.0664L36.3117 27.0667L36.1806 31.0523L31.5818 31.052L31.4502 27.0664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M31.9102 30.3877L35.852 30.3879L34.5391 46.9944L33.2251 46.9944L31.9102 30.3877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 1.31393,
    height: 0.664263,
    transform: "matrix(1 6.09612e-05 6.02914e-05 1 33.2252 46.9941)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M32.5672 30.3878L33.4222 46.9944L33.2252 46.9944L31.976 31.052L31.5818 31.052L31.4502 27.7307L31.2531 27.7306L30.9242 21.088L31.9096 20.7559L32.5672 30.3878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M35.195 30.3876L34.342 46.9941L34.5391 46.9941L35.7863 31.0519L36.1805 31.0519L36.3117 27.7306L36.5088 27.7306L36.8369 21.088L35.8514 20.7558L35.195 30.3876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1654 21.0883L30.7071 21.0879L30.5958 21.7522L37.1432 21.7526L37.1654 21.0883ZM31.3533 27.7306L37.1658 27.7309L37.1458 28.3952L31.2532 28.3948L31.3533 27.7306ZM31.976 31.0519L35.7864 31.0522L35.7733 31.7164L31.9103 31.7162L31.976 31.0519Z",
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 7.16688,
    height: 0.724651,
    transform: "matrix(1 6.09637e-05 6.02938e-05 1 19.3246 18.9404)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 18,
    width: 8,
    height: 30
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.683 18.9404L26.1332 18.9408L25.7753 26.912L25.5364 26.9119L25.4172 30.5352L25.0015 30.5352L23.6265 47.9267L22.1931 47.9266L20.816 30.5349L20.4004 30.5349L20.2807 26.9116L20.0418 26.9116L19.683 18.9404Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19.683 18.9404L26.1332 18.9408L25.7753 26.912L20.0418 26.9116L19.683 18.9404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20.2568 26.1865L25.5603 26.1868L25.4173 30.5347L20.4004 30.5344L20.2568 26.1865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20.7587 29.8105L25.0588 29.8108L23.6265 47.927L22.1931 47.9269L20.7587 29.8105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M21.4753 29.8103L22.4081 47.9266L22.1931 47.9266L20.8304 30.5349L20.4003 30.5349L20.2568 26.9116L20.0418 26.9116L19.683 19.6651L20.758 19.3028L21.4753 29.8103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M24.3421 29.8101L23.4115 47.9263L23.6265 47.9263L24.9872 30.5348L25.4172 30.5348L25.5603 26.9115L25.7753 26.9115L26.1332 19.6651L25.0581 19.3027L24.3421 29.8101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4916 19.6655L19.4462 19.665L19.3248 20.3897L26.4673 20.3901L26.4916 19.6655ZM20.1512 26.9116L26.492 26.912L26.4702 27.6366L20.0419 27.6362L20.1512 26.9116ZM20.8304 30.5349L24.9872 30.5351L24.9729 31.2598L20.7588 31.2595L20.8304 30.5349Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 7.16688,
    height: 0.724651,
    transform: "matrix(1 6.09622e-05 6.02924e-05 1 33.6459 18.8613)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 18,
    width: 7,
    height: 30
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0042 18.8613L40.4544 18.8617L40.0965 26.8329L39.8577 26.8328L39.7385 30.4561L39.3227 30.4561L37.9477 47.8476L36.5144 47.8475L35.1373 30.4558L34.7216 30.4558L34.602 26.8325L34.363 26.8325L34.0042 18.8613Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M34.0042 18.8613L40.4544 18.8617L40.0965 26.8329L34.363 26.8325L34.0042 18.8613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M34.5781 26.1074L39.8815 26.1077L39.7385 30.4556L34.7217 30.4553L34.5781 26.1074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M35.0799 29.7314L39.38 29.7317L37.9477 47.8479L36.5144 47.8478L35.0799 29.7314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M35.7966 29.7312L36.7294 47.8475L36.5143 47.8475L35.1516 30.4558L34.7216 30.4558L34.578 26.8325L34.363 26.8325L34.0042 19.586L35.0792 19.2237L35.7966 29.7312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M38.6633 29.731L37.7327 47.8472L37.9477 47.8472L39.3084 30.4556L39.7384 30.4557L39.8815 26.8324L40.0965 26.8324L40.4544 19.586L39.3794 19.2236L38.6633 29.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8128 19.5864L33.7674 19.5859L33.646 20.3106L40.7886 20.311L40.8128 19.5864ZM34.4724 26.8325L40.8133 26.8329L40.7914 27.5575L34.3631 27.5571L34.4724 26.8325ZM35.1516 30.4558L39.3084 30.456L39.2941 31.1807L35.08 31.1804L35.1516 30.4558Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 7.16688,
    height: 0.724651,
    transform: "matrix(1 6.09619e-05 6.0292e-05 1 47.2023 18.7871)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 18,
    width: 8,
    height: 30
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5606 18.7871L54.0108 18.7875L53.6529 26.7586L53.414 26.7586L53.2948 30.3819L52.8791 30.3818L51.5041 47.7734L50.0708 47.7733L48.6937 30.3816L48.278 30.3816L48.1584 26.7583L47.9194 26.7583L47.5606 18.7871Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M47.5606 18.7871L54.0108 18.7875L53.6529 26.7586L47.9194 26.7583L47.5606 18.7871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M48.1345 26.0332L53.4379 26.0335L53.2949 30.3814L48.2781 30.3811L48.1345 26.0332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M48.6363 29.6572L52.9364 29.6575L51.5041 47.7737L50.0708 47.7736L48.6363 29.6572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M49.353 29.657L50.2857 47.7733L50.0707 47.7733L48.708 30.3816L48.278 30.3815L48.1344 26.7583L47.9194 26.7583L47.5606 19.5117L48.6356 19.1495L49.353 29.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M52.2197 29.6567L51.2891 47.773L51.5041 47.773L52.8648 30.3814L53.2948 30.3815L53.4379 26.7582L53.6529 26.7582L54.0108 19.5117L52.9358 19.1493L52.2197 29.6567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3692 19.5122L47.3238 19.5117L47.2024 20.2364L54.345 20.2368L54.3692 19.5122ZM48.0288 26.7583L54.3696 26.7587L54.3478 27.4833L47.9195 27.4829L48.0288 26.7583ZM48.708 30.3816L52.8648 30.3818L52.8505 31.1065L48.6364 31.1062L48.708 30.3816Z",
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 7.64467,
    height: 0.785038,
    transform: "matrix(1 6.09616e-05 6.02917e-05 1 9.26184 16.6768)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 16,
    width: 8,
    height: 33
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6441 16.6768L16.5243 16.6772L16.1426 25.3126L15.8878 25.3126L15.7606 29.2377L15.3172 29.2377L13.8506 48.0785L12.3216 48.0785L10.8527 29.2374L10.4094 29.2374L10.2817 25.3122L10.0269 25.3122L9.6441 16.6768Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.6441 16.6768L16.5243 16.6772L16.1426 25.3126L10.0269 25.3122L9.6441 16.6768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M10.2562 24.5273L15.9132 24.5277L15.7606 29.2379L10.4093 29.2376L10.2562 24.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M10.7915 28.4521L15.3783 28.4524L13.8506 48.0783L12.3216 48.0782L10.7915 28.4521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 1.52893,
    height: 0.78504,
    transform: "matrix(1 6.09616e-05 6.02917e-05 1 12.3216 48.0781)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M11.556 28.4525L12.5509 48.0785L12.3216 48.0785L10.868 29.2375L10.4093 29.2375L10.2562 25.3123L10.0268 25.3123L9.64413 17.4619L10.7908 17.0694L11.556 28.4525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M14.6138 28.4523L13.6212 48.0782L13.8505 48.0782L15.3019 29.2374L15.7606 29.2374L15.9132 25.3122L16.1426 25.3122L16.5243 17.4619L15.3776 17.0693L14.6138 28.4523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9066 17.4624L9.39147 17.4619L9.26195 18.247L16.8807 18.2474L16.9066 17.4624ZM10.1435 25.3124L16.907 25.3128L16.8838 26.0978L10.0269 26.0974L10.1435 25.3124ZM10.868 29.2376L15.3019 29.2379L15.2867 30.0229L10.7916 30.0226L10.868 29.2376Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 7.64467,
    height: 0.785038,
    transform: "matrix(1 6.09606e-05 6.02908e-05 1 23.7865 16.5967)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 16,
    width: 8,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1688 16.5967L31.049 16.5971L30.6673 25.2325L30.4124 25.2325L30.2853 29.1577L29.8419 29.1576L28.3752 47.9985L26.8463 47.9984L25.3774 29.1574L24.934 29.1573L24.8064 25.2321L24.5515 25.2321L24.1688 16.5967Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.1688 16.5967L31.049 16.5971L30.6673 25.2325L24.5515 25.2321L24.1688 16.5967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.7808 24.4473L30.4378 24.4476L30.2853 29.1578L24.934 29.1575L24.7808 24.4473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M25.3162 28.3721L29.903 28.3723L28.3752 47.9982L26.8463 47.9981L25.3162 28.3721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 1.52893,
    height: 0.78504,
    transform: "matrix(1 6.09606e-05 6.02908e-05 1 26.8463 47.998)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M26.0806 28.3724L27.0756 47.9984L26.8463 47.9984L25.3926 29.1574L24.934 29.1574L24.7808 25.2322L24.5515 25.2322L24.1688 17.3818L25.3155 16.9893L26.0806 28.3724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M29.1385 28.3722L28.1458 47.9981L28.3752 47.9981L29.8265 29.1573L30.2852 29.1573L30.4379 25.2321L30.6672 25.2321L31.049 17.3818L29.9022 16.9892L29.1385 28.3722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4312 17.3823L23.9161 17.3818L23.7866 18.1669L31.4054 18.1673L31.4312 17.3823ZM24.6681 25.2323L31.4317 25.2327L31.4084 26.0177L24.5515 26.0173L24.6681 25.2323ZM25.3927 29.1575L29.8266 29.1578L29.8113 29.9428L25.3163 29.9425L25.3927 29.1575Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 7.64468,
    height: 0.785038,
    transform: "matrix(1 6.09602e-05 6.02904e-05 1 37.5467 16.5215)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask8",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 16,
    width: 8,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.929 16.5215L44.8092 16.5219L44.4274 25.1573L44.1726 25.1573L44.0455 29.0825L43.6021 29.0824L42.1354 47.9233L40.6065 47.9232L39.1376 29.0822L38.6942 29.0821L38.5666 25.1569L38.3117 25.1569L37.929 16.5215Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M37.929 16.5215L44.8092 16.5219L44.4274 25.1573L38.3117 25.1569L37.929 16.5215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M38.541 24.3721L44.198 24.3724L44.0455 29.0826L38.6942 29.0823L38.541 24.3721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M39.0764 28.2969L43.6632 28.2972L42.1354 47.923L40.6065 47.9229L39.0764 28.2969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 1.52894,
    height: 0.785038,
    transform: "matrix(1 6.09602e-05 6.02904e-05 1 40.6064 47.9229)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M39.8408 28.2972L40.8358 47.9233L40.6065 47.9232L39.1528 29.0822L38.6942 29.0822L38.541 25.157L38.3117 25.157L37.929 17.3066L39.0757 16.9141L39.8408 28.2972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M42.8987 28.297L41.906 47.9229L42.1354 47.9229L43.5867 29.0821L44.0454 29.0821L44.1981 25.1569L44.4274 25.1569L44.8092 17.3066L43.6624 16.914L42.8987 28.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1914 17.3071L37.6763 17.3066L37.5468 18.0917L45.1656 18.0921L45.1914 17.3071ZM38.4283 25.1571L45.1919 25.1575L45.1686 25.9425L38.3117 25.9421L38.4283 25.1571ZM39.1528 29.0823L43.5868 29.0826L43.5715 29.8676L39.0764 29.8673L39.1528 29.0823Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 7.64468,
    height: 0.785038,
    transform: "matrix(1 6.09593e-05 6.02895e-05 1 52.0714 16.4414)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask9",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 16,
    width: 8,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4536 16.4414L59.3338 16.4418L58.9521 25.0772L58.6973 25.0772L58.5701 29.0024L58.1267 29.0024L56.6601 47.8432L55.1311 47.8431L53.6622 29.0021L53.2189 29.0021L53.0912 25.0769L52.8364 25.0769L52.4536 16.4414Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M52.4536 16.4414L59.3338 16.4418L58.9521 25.0772L52.8364 25.0769L52.4536 16.4414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M53.0657 24.292L58.7227 24.2923L58.5701 29.0026L53.2189 29.0022L53.0657 24.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M53.601 28.2168L58.1878 28.2171L56.6601 47.8429L55.1311 47.8428L53.601 28.2168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 1.52894,
    height: 0.785038,
    transform: "matrix(1 6.09593e-05 6.02895e-05 1 55.1311 47.8428)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M54.3655 28.2172L55.3605 47.8432L55.1311 47.8432L53.6775 29.0022L53.2188 29.0021L53.0657 25.0769L52.8363 25.0769L52.4536 17.2265L53.6003 16.8341L54.3655 28.2172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M57.4233 28.2169L56.4307 47.8428L56.66 47.8428L58.1114 29.002L58.5701 29.002L58.7227 25.0768L58.9521 25.0769L59.3338 17.2265L58.1871 16.8339L57.4233 28.2169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7161 17.227L52.201 17.2266L52.0715 18.0116L59.6902 18.0121L59.7161 17.227ZM52.953 25.077L59.7166 25.0774L59.6933 25.8624L52.8364 25.862L52.953 25.077ZM53.6775 29.0022L58.1114 29.0025L58.0962 29.7875L53.6011 29.7873L53.6775 29.0022Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51004 29.2939C6.40549 29.3 5.51499 30.2003 5.52105 31.3049L5.54852 36.3115L2.96175 36.3257C1.8572 36.3318 0.966696 37.2321 0.972757 38.3366L0.97887 39.4507L5.61482 39.4253C5.82126 40.3156 6.62178 40.9768 7.57412 40.9716L61.6728 40.6748C62.6251 40.6695 63.4183 39.9995 63.615 39.107L69.0154 39.0774L69.0093 37.9633C69.0032 36.8588 68.1029 35.9683 66.9984 35.9743L63.6471 35.9927L63.6197 30.9861C63.6136 29.8816 62.7133 28.991 61.6087 28.9971L7.51004 29.2939Z",
    fill: "#F79689"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3538 36.0053L7.84188 36.2989L7.54849 36.3005L5.54852 36.3115L5.53754 34.3115L5.53143 33.1975L5.52105 31.3049C5.51499 30.2003 6.40549 29.3 7.51004 29.2939L7.80344 29.2923L7.8248 33.1849L61.3367 32.8913L61.3153 28.9987L61.6087 28.9971C62.7133 28.991 63.6136 29.8816 63.6197 30.9861L63.6301 32.8787L63.6362 33.9928L63.6471 35.9927L61.6472 36.0037L61.3538 36.0053ZM0.972757 38.3366C0.966696 37.2321 1.8572 36.3318 2.96175 36.3257L3.25515 36.3241L3.27224 39.4381L0.97887 39.4507L0.972757 38.3366ZM66.9983 35.9743L66.705 35.976L66.722 39.09L69.0154 39.0774L69.0093 37.9633C69.0032 36.8588 68.1029 35.9683 66.9983 35.9743Z",
    fill: "#DE7062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.402 41.1488C66.3187 41.4011 66.2176 41.7243 66.1035 42.1217C65.782 43.2418 65.3575 44.9521 64.9375 47.3307C64.1107 52.0137 63.3018 59.2874 63.333 69.7499L54.7568 69.7969L52.9323 69.0654L52.8414 69.0289L52.7434 69.0295L16.814 69.2266L16.7161 69.2271L16.6256 69.2646L14.8092 70.0161L6.99757 70.059C6.91744 59.7897 6.12351 52.5305 5.34084 47.8142C4.94318 45.4179 4.54843 43.6781 4.25169 42.5335C4.14008 42.103 4.04234 41.7567 3.96353 41.4914L66.402 41.1488Z",
    fill: "#F5F7F9",
    fillOpacity: 0.6,
    stroke: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27649 40.2168C3.27649 40.2168 6.3813 48.7636 6.49663 69.7834L14.9056 69.7373L16.8125 68.9483L52.7419 68.7511L54.6573 69.5192L63.8308 69.4688C63.7133 48.0598 66.7263 39.8687 66.7263 39.8687",
    stroke: "#E5ECF0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.978821 39.4512L69.0154 39.0779V39.0779C69.0201 39.9378 68.3268 40.6387 67.4669 40.6434L2.54439 40.9997C1.68447 41.0044 0.983539 40.3111 0.978821 39.4512V39.4512Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1241 68.7487L53.0519 55.5894C53.0302 51.6215 47.852 45.4216 34.8205 45.4931C21.7891 45.5646 16.3363 51.8228 16.3581 55.7907L16.4303 68.95",
    stroke: "#E5ECF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 26.9917,
    y: 43.2012,
    width: 15.2893,
    height: 4.67113,
    rx: 1,
    transform: "rotate(-0.314367 26.9917 43.2012)",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9493 5.55354L16.2269 6.1113L16.85 6.10788L51.6327 5.91704L52.1381 5.91426L52.4356 5.50563L53.2763 4.35095L64.8122 4.28766L66.4161 34.9772L2.76857 35.3265L4.03553 4.62112L15.4539 4.55848L15.9493 5.55354Z",
    fill: "#F5F7F9",
    fillOpacity: 0.6,
    stroke: "#E5ECF0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.08 5.1123L17.6431 11.332",
    stroke: "#E5ECF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7739 4.91113L51.2791 11.1476",
    stroke: "#E5ECF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2 5.85742L46.6625 5.7232L46.69 10.7298C46.6961 11.8344 45.8056 12.7347 44.701 12.7408L24.2384 12.853C23.1338 12.8591 22.2335 11.9686 22.2274 10.864L22.2 5.85742Z",
    stroke: "#E5ECF0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.1857,
    y: 35.6351,
    width: 14.8183,
    height: 13.5704,
    rx: 2,
    transform: "rotate(-0.314367 27.1857 35.6351)",
    fill: "#F5F7F9",
    fillOpacity: 0.6,
    stroke: "#E5ECF0",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.5665,
    height: 69.57,
    fill: "white",
    transform: "translate(0 0.381836) rotate(-0.314367)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.56964,
    height: 42.5128,
    fill: "white",
    transform: "matrix(1 6.09625e-05 6.02929e-05 1 16.2747 20.502)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.56964,
    height: 42.5128,
    fill: "white",
    transform: "matrix(1 6.09611e-05 6.02915e-05 1 43.5914 20.3525)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.56964,
    height: 42.5128,
    fill: "white",
    transform: "matrix(1 6.09611e-05 6.02915e-05 1 30.5957 20.4238)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.16688,
    height: 46.3776,
    fill: "white",
    transform: "matrix(1 6.09635e-05 6.02939e-05 1 19.3246 18.9404)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.16688,
    height: 46.3776,
    fill: "white",
    transform: "matrix(1 6.09621e-05 6.02925e-05 1 33.6459 18.8613)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.16688,
    height: 46.3776,
    fill: "white",
    transform: "matrix(1 6.09617e-05 6.02921e-05 1 47.2023 18.7871)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64467,
    height: 50.2424,
    fill: "white",
    transform: "matrix(1 6.09614e-05 6.02918e-05 1 9.26184 16.6768)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64467,
    height: 50.2424,
    fill: "white",
    transform: "matrix(1 6.09605e-05 6.02909e-05 1 23.7865 16.5967)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64468,
    height: 50.2425,
    fill: "white",
    transform: "matrix(1 6.09601e-05 6.02905e-05 1 37.5467 16.5215)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64468,
    height: 50.2425,
    fill: "white",
    transform: "matrix(1 6.09592e-05 6.02897e-05 1 52.0714 16.4414)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2TipBox);
export default __webpack_public_path__ + "static/media/P2_Tip_Box.b9f40226292582a3b8a1066b54876c04.svg";
export { ForwardRef as ReactComponent };